export { fetchCategories } from './fetchCategories'
export { normalizeCategoriesData } from './normalizeCategoriesData'
export { fetchFaculties } from './fetchFaculties'
export { normalizeFacultiesData } from './normalizeFacultiesData'
